//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngUserProfile', srsngUserProfile);

    function srsngUserProfile($rootScope, Localization, userSettingsService, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/user-profile/user-profile.html',
            scope: {
                showUserProfileModal: '='
             },
            controller: controller
        };

        function controller($scope) {

            // $scope.tabModalConfig = [
            //     {
            //         label: "User Profile",
            //         directive: "<srsng-user-profile-basic></srsng-user-profile-basic>"
            //     },
            //     {
            //         label: "Second",
            //         directive: "<srsng-second-directive></srsng-second-directive>"
            //     }
            // ]

            $scope.cancel = cancel;
            $scope.save = save;

            $scope.errors = [];
            $scope.showError = false;
            $scope.displayErrors = displayErrors;
            $scope.closeErrorDialogue = closeErrorDialogue;

            $rootScope.$on(Event.USER_LOGGED_OUT, () => {
                cancel();
            });
            
            function cancel() {
                $rootScope.$emit('userProfile:cancel');
                $scope.showUserProfileModal = false;
            }

            function save() {
                $rootScope.$emit('userProfile:save');
                $scope.showUserProfileModal = false;
            }

            function closeErrorDialogue() {
                $scope.showError = false;
            }

            function  displayErrors(errors) {
                $scope.errors = errors;
                $scope.showError = true;
            }
            
        }

    }

})();

